import type { ProspectMatterType, ProspectPracticeArea } from '../enums';

/**
 * Intake form versioning by practice area and matter type.
 *
 * - V1 intake: RealEstate (Sale, Purchase, Refinance, PrivateLender).
 * - V2 intake: all other practice area + matter type combinations.
 *
 * Quote & Intake (`QuoteIntake` template type) is V1-only. V2 practice areas support
 * IntakeOnly; the combined quote-then-intake flow was dropped for V2.
 */
export function getIsIntakeFormV2(
    practiceArea?: ProspectPracticeArea | string | null,
    matterType?: ProspectMatterType | string | null,
): boolean {
    if (!practiceArea || !matterType) return false;
    if (
        practiceArea === 'RealEstate' &&
        ['Sale', 'Purchase', 'Refinance', 'PrivateLender'].includes(matterType)
    ) {
        return false;
    }
    return true;
}
